// extracted by mini-css-extract-plugin
var _1 = "PageGiftBucksConfirmation__actions--e8lUg";
var _2 = "PageGiftBucksConfirmation__btnPrimary--A8pvv";
var _3 = "PageGiftBucksConfirmation__confirmationContent--OXoxy";
var _4 = "PageGiftBucksConfirmation__giftBucksConfirmation--S1iTg";
var _5 = "PageGiftBucksConfirmation__giftBucksConfirmationContainer--PIRSq";
export { _1 as "actions", _2 as "btnPrimary", _3 as "confirmationContent", _4 as "giftBucksConfirmation", _5 as "giftBucksConfirmationContainer" }
